import React, { Component } from "react";
import { Link } from "react-router-dom";
import StarRatings from "react-star-ratings";
import { ReactSVG } from "react-svg";
import CommonService from "../../../../services/common-service";
import LocalStoreService from "../../../../services/localStore-service";
import AdsService from "../../../../services/ads-service";

class VerticalItem extends Component {
  constructor() {
    super();
    this.adsService = new AdsService();
    this.commonService = new CommonService();
    this.localService = new LocalStoreService();
    this.state = {
      car: {},
      bike: {},
      className: "",
      isAuth: false,
      userId: 0,
    };
  }

  componentDidMount() {
    this.setState({
      isAuth: this.checkAuth(),
      userId: this.localService.getUserId(),
      car: this.props.data ? this.props.data : {},
      bike: this.props.data ? this.props.data : {},
    });
  }

  componentDidUpdate(prevProp) {
    if (this.props.data) {
      if (prevProp.data !== this.props.data) {
        this.setState({
          car: this.props.data,
          bike: this.props.data,
        });
      }
    }
  }

  checkAuth = () => {
    const token = this.localService.getUserToken();
    if (token) {
      return true;
    } else {
      return false;
    }
  };

  checkFavourite = (product) => {
    const { userId } = this.state;
    if (product && product.favourites && product.favourites.length) {
      let isFavourite = false;
      product.favourites.forEach((fav) => {
        if (fav.id) {
          if (fav.id === userId) {
            isFavourite = true;
          }
        }
      });
      return isFavourite;
    }
  };

  handleFavourite = (product, type) => {
    const { userId } = this.state;

    if (userId) {
      if (type === "addFav") {
        this.addFavourite(product);
        this.props.onFavourite(product, "removeFav");
      } else if (type === "removeFav") {
        this.removeFavourite(product);
        this.props.onFavourite(product, "removeFav");
      }
    }
  };

  addFavourite = (product) => {
    const { userId } = this.state;
    let formData = { userId, carId: product.id };

    this.adsService
      .addFavouriteCar(formData)
      .then((res) => {
        const { message } = res.data;
        if (message === "Favourite added successfully") {
          this.commonService.showToast("Favourite added successfully", "success");
          this.props.onFavourite();
        } else {
          this.commonService.showToast("Favourite not added!", "error");
        }
      })
      .catch((err) => {
        this.commonService.showToast("Something went wrong!", "error");
        this.adsService.handleError(err);
      });
  };

  removeFavourite = (product) => {
    const { userId } = this.state;
    let formData = { userId, bikeId: product.id, carId: product.id };
    this.adsService
      .removeFavouriteCar(formData)
      .then((res) => {
        const { message } = res.data;
        if (message === "Favourite removed successfully") {
          this.commonService.showToast("Favourite removed successfully", "success");
          this.props.onFavourite();
        } else {
          this.commonService.showToast("Favourite not added!", "error");
        }
      })
      .catch((err) => {
        this.commonService.showToast("Something went wrong!", "error");
        this.adsService.handleError(err);
      });
  };

  render() {
    const { car, bike, isAuth } = this.state;
    const { images, model } = car ? car : {};
    // const { images, model } = bike ? bike : {};
    return (
      <div>
        <div className="popular-cars-img">
          {this.props.category === "car" ? (
            <Link
              to={{
                pathname: `/new-cars/${
                  car && car.make
                    ? car.make.name
                        .toLowerCase()
                        .trim()
                        .replace(/\s/g, "-")
                        .replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-") // for replacing forward slashes
                    : ""
                }/${
                  car && car.model
                    ? car.model.name
                        .toLowerCase()
                        .trim()
                        .replace(/\s/g, "-")
                        .replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-") // for replacing forward slashes
                    : ""
                }-${car.model ? car.model.id : ""}`,
              }}
            >
              <img
                style={{ objectFit: "contain" }}
                className="card-img-top"
                src={images && images.length ? images[0].url : require("../../../../assets/Images/car-placeholder.png")}
                alt="featured car"
              />
            </Link>
          ) : (
            <Link
              to={{
                pathname: `/new-bikes/${bike && bike.title ? bike.title.toLowerCase().trim().replace(/\s/g, "-").replace(/\//g, "_") : ""}-${bike.id}`,
              }}
            >
              <img loading="lazy" className="card-img-top" src={images && images.length ? images[0].url : require("../../../../assets/Images/car-placeholder.png")} alt="featured car" />
            </Link>
          )}
        </div>
        <div className="popular-cars-details">
          <h5>
            {this.props.category == "car" ? (
              <span className="card-title">{car && `${car.make && car.make.name} ${car.model && car.model.name} ${car.year && car.year}`}</span>
            ) : (
              <span className="card-title">
                <span>{bike && bike.year ? bike.year : ""}</span>&nbsp;
                {bike && bike.title ? bike.title : ""}
              </span>
            )}
          </h5>
          <p className="popular-cars-price">
            {this.props.category == "car" ? (
              <span>
                PKR {this.commonService.getPriceIntoWords(car && car.min)} to {this.commonService.getPriceIntoWords(car && car.max)}
              </span>
            ) : (
              <span>PKR {this.commonService.getPriceIntoWords(bike && bike.price)}</span>
            )}
          </p>
        </div>
      </div>
    );
  }
}

export default VerticalItem;
